class AnimationSubsTextGallery {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleSubsTextGallery = this.sectionsContainer.querySelectorAll('.subs-text-gallery');
		
		if (!this.$moduleSubsTextGallery.length)
			return;
		
		this.$moduleSubsTextGalleryElements = [];
		this.$moduleSubsTextGallery.forEach(module => {
			this.$moduleSubsTextGalleryElements.push(module.querySelectorAll('.anima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleSubsTextGallery.forEach((module, index) => {
		    console.log(this.$moduleSubsTextGalleryElements[index])
			gsap.set(module, { opacity: 1 });
			gsap.set(this.$moduleSubsTextGalleryElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		const moduleSubsTextGallery = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleSubsTextGallery[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleSubsTextGalleryElements[index], { clearProps: true });
			}
        });

        moduleSubsTextGallery.addLabel('step1');
        moduleSubsTextGallery.to(this.$moduleSubsTextGallery[index], { opacity: 1, duration: 1 }, 'step1');
		moduleSubsTextGallery.to(this.$moduleSubsTextGalleryElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default AnimationSubsTextGallery;
